import React from 'react';
const GutterContext = /*#__PURE__*/React.createContext(false);
export default GutterContext;